<template>
  <tabs :tabs="tabs" :entityType="entityType" :entityId="entityId" />
</template>

<script>
import Tabs from '@/components/tabs/Tabs';
import { tryParseInt } from '@/utils/number';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Widok klubu
// @group Club
export default {
  components: { Tabs },
  data() {
    const clubId = this.$route.params.clubId.toString();
    return {
      tabs: [
        { title: 'tabs.club.details', route: { name: 'club', params: { clubId } }, permissions: ['CLUB.GET'] },
        {
          title: 'tabs.club.edit',
          route: { name: 'clubEdit', params: { clubId } },
          permissions: ['CLUB.UPDATE']
        },
        {
          title: 'tabs.club.teams',
          route: { name: 'teams', params: { clubId } },
          permissions: ['TEAM.LIST']
        },
        {
          title: 'tabs.club.offers',
          route: { name: 'offers', params: { clubId } },
          permissions: ['OFFER.LIST']
        },
        {
          title: 'tabs.club.calendar',
          route: { name: 'clubCalendar', params: { clubId, view: 'week' } },
          permissions: ['CLUB.EVENTS']
        },
        {
          title: 'tabs.club.fee',
          route: { name: 'clubFees', params: { clubId } },
          permissions: ['FEE.LIST']
        },
        {
          title: 'tabs.club.exam',
          route: { name: 'clubExams', params: { clubId } },
          permissions: ['EXAM.LIST']
        }
      ],
      entityType: TableName.Club,
      entityId: clubId
    };
  }
};
</script>
